import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import server from '../services/server';
import { useAuth } from '../context/AuthContext';

export default function AuthRedirect() {
    // Apenas para debug, mostra que o componente foi chamado
    console.log("Chamou aqui ")

    // Hook para acessar os parâmetros da URL (ex: ?token=abc&route=perfil)
    const [params] = useSearchParams();
    // Hook para navegação programática
    const navigate = useNavigate();

    // Função responsável por tratar a autenticação via token na URL
    const Authentication = async () => {
        try {
            // Pega o token e a rota dos parâmetros da URL
            const token = params.get('token');
            const route = params.get('route');
            
            if (token && route) {
                // Se ambos existem, redireciona para a rota desejada
                navigate(`/${route}`, { replace: true });
            } else {
                // Se não há parâmetros válidos, redireciona para a tela de login
                navigate('/', { replace: true });
            }
        } catch (error) {
            // Em caso de erro, redireciona para a tela de login
            console.error('Erro na autenticação:', error);
            navigate('/', { replace: true });
        }
    };

    // useEffect executa Authentication assim que o componente monta
    useEffect(() => {
        Authentication();
    }, []);

    // Exibe uma mensagem enquanto faz o redirecionamento
    return <>Carregando Dados</>;
}
